import { shortenCompanyName } from '../utils/formatters';
import {
  SUG_MUTZAR, SUG_MUTZAR_CATEGORY, SUG_MUTZAR_ICON,
  STATUS_POLISA, SUG_TOCHNIT, SUG_KISUY, MIN, MATZAV_MISHPACHTI,
  KOD_ZIKA, PENSIA_VATIKA, SUG_KEREN_PENSIA, KOD_CHISHUV_SACHAR,
  SUG_HAFRASHA, SUG_MAFKID, KOD_SUG_PEULA, KOD_EMTZAEI_TASHLUM, TADIRUT_TASHLUM,
  SEIF_14, KAYEMET_HATAVA, SUG_HATAVA, HUTAL_SHIABUD, HUTAL_IKUL,
  KAYAM_CHOV, SUG_HOV, TIKUN_190, KOLEL_ZAKAUT_AGACH, SUG_KUPA,
  SUG_HATZMADA, OFEN_TASHLUM_SCHUM_BITUACH, KAVOA_MISHTANE,
  MESHALEM_HAKISUY, IND_YES_NO, KITZBA_ZMUDA_LAMADAD, NACHUT_MITPATAHAT,
  SUG_MEVUTACH, SUG_ISUK, SUG_KISUI_ETZEL_YATZRAN, KOD_SUG_TOSEFET,
  SUG_HANACHA_KISUY, SUG_MASLUL_LEBITUAH, SUG_POLISA, KISUY_ISHY_KVOZATI,
  SUG_HATVIAA, KOD_STATUS_TVIA, OFEN_TASHLUM_TVIA, OFEN_HATZMADAT_GVIA,
  SUG_TEUDA, SUG_TEUDA_MESHALEM, KOD_SUG_MUTZAR_BITUACH,
  MESHALEM_DMEI_HABITUAH_MITRIYA, TADIRUT_HATSHLUM_MITRIYA,
  STATUS_MAASIK,
  MEVUTACH_BAKEREN, VITUR_KISUY_BITUCHI, SUG_VITOR_SHAERIM, NECHUT_MITPATAHAT_PENSIA,
} from '../utils/fieldMaps';

// ── helpers ──────────────────────────────────────────────────────────────────
const g = (el, tag) => {
  const found = el.getElementsByTagName(tag);
  if (!found.length) return null;
  const v = found[0].textContent?.trim();
  return v && v !== "" ? v : null;
};

const gNum = (el, tag) => {
  const v = g(el, tag);
  if (v === null) return null;
  const n = parseFloat(v);
  return isNaN(n) ? null : n;
};

export const fmtDate = (s) => {
  if (!s) return null;
  const d = String(s).replace(/\D/g, "");
  if (d.length === 8) return `${d.slice(6, 8)}/${d.slice(4, 6)}/${d.slice(0, 4)}`;
  if (d.length === 6) return `${d.slice(4, 6)}/${d.slice(0, 4)}`;
  return s;
};

export const fmtMoney = (v, decimals = 0) => {
  if (v === null || v === undefined || v === 0) return null;
  return v.toLocaleString("he-IL", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }) + " ₪";
};

export const fmtPct = (v, decimals = 2) => {
  if (v === null || v === undefined || v === 0) return null;
  return v.toFixed(decimals) + "%";
};

const lookup = (table, key) => {
  if (key === null || key === undefined || key === "") return key;
  const sKey = String(key);
  return table[sKey] || key;
};

// ── parse sheerim (survivors) ─────────────────────────────────────────────────
function parseSheerim(polisaEl) {
  const sheerim = [];
  const sheerEls = polisaEl.getElementsByTagName("Sheer");
  for (let i = 0; i < sheerEls.length; i++) {
    const s = sheerEls[i];
    const firstName = g(s, "SHEM-PRATI-SHEERIM");
    const lastName  = g(s, "SHEM-MISHPACHA-SHEERIM");
    if (!firstName && !lastName) continue;
    sheerim.push({
      name: `${firstName || ""} ${lastName || ""}`.trim(),
      zika: lookup(KOD_ZIKA, g(s, "KOD-ZIHUI-SHEERIM")),
      id:   g(s, "MISPAR-ZIHUY-SHEERIM"),
      bday: fmtDate(g(s, "TAARICH-LEIDA")),
      gender: lookup(MIN, g(s, "MIN")),
    });
  }
  return sheerim;
}

// ── parse mutavim (beneficiaries) ─────────────────────────────────────────────
function parseMutavim(polisaEl) {
  const mutavim = [];
  const els = polisaEl.getElementsByTagName("Mutav");
  
  const KOD_ZIHUY_MUTAV_LABEL = {
    "1": "יחיד ספציפי", "2": "בני זוג", "3": "ילדים / עיזבון",
    "4": "עיזבון", "5": "אחר",
  };
  const SUG_ZIHUY_MUTAV_LABEL = {
    "1": "ת.ז.", "2": "ח.פ.", "3": "ח.צ.", "4": "דרכון",
    "5": "אחר", "6": "לא ידוע", "7": "לפי מינוי",
  };
  
  const seen = new Set();

  for (let i = 0; i < els.length; i++) {
    const mutav = els[i];
    const firstName = g(mutav, "SHEM-PRATI-MUTAV");
    const lastName  = g(mutav, "SHEM-MISHPACHA-MUTAV");
    const fullName  = `${firstName || ""} ${lastName || ""}`.trim() || null;
    const sugZihuy  = g(mutav, "SUG-ZIHUY-MUTAV");
    const kodZihuy  = g(mutav, "KOD-ZIHUY-MUTAV");
    const pct       = g(mutav, "ACHUZ-MUTAV"); // can be string or num
    const id        = g(mutav, "MISPAR-ZIHUY-MUTAV");
    const zika      = lookup(KOD_ZIKA, g(mutav, "SUG-ZIKA"));

    let displayName = fullName;
    if (!displayName) {
      if (kodZihuy === "3") displayName = "ילדים / עיזבון";
      else if (kodZihuy === "2") displayName = "בני זוג";
      else if (kodZihuy === "4") displayName = "עיזבון";
      else if (sugZihuy === "7") displayName = "לפי מינוי";
      else if (sugZihuy === "6") displayName = "לא ידוע";
      else displayName = KOD_ZIHUY_MUTAV_LABEL[kodZihuy] || "מוטב";
    }

    const dedupeKey = `${displayName}_${id || ""}_${zika || ""}_${pct || ""}`;
    if (seen.has(dedupeKey)) continue;
    seen.add(dedupeKey);

    mutavim.push({
      id,
      name:        fullName,
      displayName,
      zika,
      pct,
      bday:        fmtDate(g(mutav, "TAARICH-LEIDA-MUTAV")),
      sugZihuy:    SUG_ZIHUY_MUTAV_LABEL[sugZihuy] || sugZihuy,
      kodZihuy:    KOD_ZIHUY_MUTAV_LABEL[kodZihuy] || kodZihuy,
      hagdara:     g(mutav, "HAGDARAT-MUTAV") === "1" ? "קבוע" : "משתנה",
    });
  }
  return mutavim;
}

// ── parse hafkadot (deposits) ─────────────────────────────────────────────────
function parseHafkadot(polisaEl) {
  const rows = [];
  const hafkadaEls = polisaEl.getElementsByTagName("PerutHafrashotLePolisa");
  for (let i = 0; i < hafkadaEls.length; i++) {
    const h = hafkadaEls[i];
    rows.push({
      type:    lookup(SUG_HAFRASHA, g(h, "SUG-HAFRASHA")),
      payer:   g(h, "SUG-HAMAFKID") === "1" ? "עובד" : "מעביד",
      pct:     gNum(h, "ACHUZ-HAFRASHA"),
      amount:  gNum(h, "SCHUM-HAFRASHA"),
    });
  }
  return rows;
}

// ── parse investment tracks ───────────────────────────────────────────────────
function parseMaslulim(polisaEl) {
  const tracks = [];
  const els = polisaEl.getElementsByTagName("PerutMasluleiHashkaa");
  for (let i = 0; i < els.length; i++) {
    const m = els[i];
    let name = g(m, "SHEM-MASLUL-HASHKAA");
    if (!name) continue;

    name = name.replace(/^\d+/, "").trim();
    const code = g(m, "KOD-MASLUL-HASHKAA");
    let trackId = code;
    if (code && code.length >= 7) {
      const codeNum = parseInt(code.slice(-7), 10);
      if (!isNaN(codeNum)) {
        name = `${name} - ${codeNum}`;
        trackId = String(codeNum);
      }
    }

    tracks.push({
      name,
      balance:    gNum(m, "SCHUM-TZVIRA-BAMASLUL"),
      pct:        gNum(m, "ACHUZ-HAFKADA-LEHASHKAA"),
      dmeiHaf:    gNum(m, "SHEUR-DMEI-NIHUL-HAFKADA"),
      dmeiTzv:    gNum(m, "SHEUR-DMEI-NIHUL-HISACHON"),
      dmeiHafMivne: gNum(m, "SHEUR-DMEI-NIHUL-HAFKADA-MIVNE"),
      dmeiTzvMivne: gNum(m, "SHEUR-DMEI-NIHUL-HISACHON-MIVNE"),
      tsua:       gNum(m, "TSUA-NETO"),
      code,
      trackId,
    });
  }
  return tracks;
}

// ── parse kisuim (coverages) ──────────────────────────────────────────────────
function parseKisuim(polisaEl) {
  const covers = [];
  const els = polisaEl.getElementsByTagName("ZihuiKisui");
  for (let i = 0; i < els.length; i++) {
    const z = els[i];
    const kisui = z.getElementsByTagName("PirteiKisuiBeMutzar")[0];
    const bituahYesodi = z.getElementsByTagName("SchumeiBituahYesodi")[0];
    const pensiaKisui  = z.getElementsByTagName("KisuiBKerenPensia")[0];
    const tosafot      = z.getElementsByTagName("PirteiTosafot")[0];
    const mutav        = z.getElementsByTagName("Mutav")[0];

    const sugKisuy = kisui ? lookup(SUG_KISUY, g(kisui, "SUG-KISUY-BITOCHI")) : null;
    if (!sugKisuy && !g(z, "SHEM-KISUI-YATZRAN")) continue;

    const KOD_ZIHUY_MUTAV_LABEL = {
      "1": "יחיד ספציפי", "2": "בני זוג", "3": "ילדים / עיזבון",
      "4": "עיזבון", "5": "אחר",
    };
    const SUG_ZIHUY_MUTAV_LABEL = {
      "1": "ת.ז.", "2": "ח.פ.", "3": "ח.צ.", "4": "דרכון",
      "5": "אחר", "6": "לא ידוע", "7": "לפי מינוי",
    };
    let mutavData = null;
    if (mutav) {
      const firstName = g(mutav, "SHEM-PRATI-MUTAV");
      const lastName  = g(mutav, "SHEM-MISHPACHA-MUTAV");
      const fullName  = `${firstName || ""} ${lastName || ""}`.trim() || null;
      const sugZihuy  = g(mutav, "SUG-ZIHUY-MUTAV");
      const kodZihuy  = g(mutav, "KOD-ZIHUY-MUTAV");
      const pct       = gNum(mutav, "ACHUZ-MUTAV");

      // Build display name — use actual name if exists, otherwise describe the type
      let displayName = fullName;
      if (!displayName) {
        if (kodZihuy === "3") displayName = "ילדים / עיזבון";
        else if (kodZihuy === "2") displayName = "בני זוג";
        else if (kodZihuy === "4") displayName = "עיזבון";
        else if (sugZihuy === "7") displayName = "לפי מינוי";
        else if (sugZihuy === "6") displayName = "לא ידוע";
        else displayName = KOD_ZIHUY_MUTAV_LABEL[kodZihuy] || "מוטב";
      }

      mutavData = {
        id:          g(mutav, "MISPAR-ZIHUY-MUTAV"),
        name:        fullName,
        displayName,
        zika:        lookup(KOD_ZIKA, g(mutav, "SUG-ZIKA")),
        pct,
        bday:        fmtDate(g(mutav, "TAARICH-LEIDA-MUTAV")),
        sugZihuy:    SUG_ZIHUY_MUTAV_LABEL[sugZihuy] || sugZihuy,
        kodZihuy:    KOD_ZIHUY_MUTAV_LABEL[kodZihuy] || kodZihuy,
        hagdara:     g(mutav, "HAGDARAT-MUTAV") === "1" ? "קבוע" : "משתנה",
      };
    }

    // Insured person for this coverage (may differ from policy owner, e.g. spouse in mortgage risk)
    const mevutachEl = z.getElementsByTagName("PirteiMevutach")[0];
    const mevutach = mevutachEl ? {
      id:       g(mevutachEl, "MISPAR-ZIHUY-LAKOACH"),
      sugTeuda: lookup(SUG_TEUDA, g(mevutachEl, "SUG-TEUDA")),
    } : null;

    const miktsoaEl = z.getElementsByTagName("Miktsoa-Isuk-Tachviv")[0];
    const miktsoa = miktsoaEl ? {
      kodMiktzoa: g(miktsoaEl, "KOD-MIKTZOA"),
      tchumIsuk:  g(miktsoaEl, "TCHUM-ISUK-CHADASH"),
      tachvivim:  g(miktsoaEl, "TACHVIVIM-O-ISUKIM"),
    } : null;

    covers.push({
      name:        g(z, "SHEM-KISUI-YATZRAN"),
      misparKisui: g(z, "MISPAR-KISUI-BE-YATZRAN"),
      sugKisuiYatzran: lookup(SUG_KISUI_ETZEL_YATZRAN, g(z, "SUG-KISUI-ETZEL-YATZRAN")),
      polisaNegdit: g(z, "MISPAR-POLISA-O-HESHBON-NEGDI"),
      sugKisuy,
      startDate:   kisui ? fmtDate(g(kisui, "TAARICH-TCHILAT-KISUY")) : null,
      endDate:     kisui ? fmtDate(g(kisui, "TAARICH-TOM-KISUY")) : null,
      stopPayDate: kisui ? fmtDate(g(kisui, "TAARICH-HAFSAKAT-TASHLUM")) : null,
      premium:     kisui ? gNum(kisui, "DMEI-BITUAH-LETASHLUM-BAPOAL") : null,
      alutKisui:   kisui ? gNum(kisui, "ALUT-KISUI") : null,
      tosefetPct:  tosafot ? gNum(tosafot, "SHEUR-TOSEFET") : null,
      // Full underwriting loadings list (medical / occupational additions)
      tosafot: Array.from(z.getElementsByTagName("PirteiTosafot")).map(t => ({
        kod:     lookup(KOD_SUG_TOSEFET, g(t, "KOD-SUG-TOSEFET")),
        taarif:  gNum(t, "TOSEFET-TAARIF"),
        sheur:   gNum(t, "SHEUR-TOSEFET"),
        promil:  gNum(t, "PROMIL-TOSEFET"),
        endDate: fmtDate(g(t, "TAARICH-TOM-TOSEFET")),
      })).filter(t => t.kod || t.taarif || t.sheur || t.promil),
      hanachaPct:  kisui ? gNum(kisui, "SHIUR-HANACHA-BEKISUI") : null,
      hanacha:     kisui ? g(kisui, "HANACHA") === "1" : false,
      hanachaEnd:  kisui ? fmtDate(g(kisui, "MOED-SIUM-TKUFAT-HANACHA")) : null,
      sugHanachaKisuy: kisui ? lookup(SUG_HANACHA_KISUY, g(kisui, "SUG-HANACHA-KISUY")) : null,
      erechHanacha:    kisui ? gNum(kisui, "ERECH-HANACHA-BEKISUI") : null,
      tnaeiHanacha:    kisui ? g(kisui, "TNAEI-HANACHA") : null,
      tadirutShinuyDmei: kisui ? gNum(kisui, "TADIRUT-SHINUY-DMEI-HABITUAH-BESHANIM") : null,
      // Insurance sums — per-coverage sum lives in PirteiKisuiBeMutzar (SCHUM-BITUACH);
      // the yesodi block only carries the death sum of the base coverage.
      schumBituach:   kisui ? gNum(kisui, "SCHUM-BITUACH") : null,
      schumSheur:     kisui ? gNum(kisui, "SCHUM-SHEUR") : null,
      achuzMeSachar:  kisui ? gNum(kisui, "ACHUZ-MESACHAR") : null,
      achuzMeSchumYesodi: kisui ? gNum(kisui, "ACHUZ-ME-SCM-BTH-YESODI") : null,
      bituachLemavet: bituahYesodi ? gNum(bituahYesodi, "SCHUM-BITUAH-LEMAVET") : null,
      tikratGagMavet: bituahYesodi ? gNum(bituahYesodi, "TIKRAT-GAG-HATAM-LEMIKRE-MAVET") : null,
      // Per XSD 008 these two live in PirteiKisuiBeMutzar; keep the old yesodi
      // location as fallback for producers that deviate from the schema.
      tikratGagAka:   (kisui ? gNum(kisui, "TIKRAT-GAG-HATAM-LE-O-K-A") : null)
                      ?? (bituahYesodi ? gNum(bituahYesodi, "TIKRAT-GAG-HATAM-LE-O-K-A") : null),
      achuzHagdalatGag: (kisui ? gNum(kisui, "ACHUZ-HAGDALAT-GAG-HATAM-O-K-A") : null)
                      ?? (bituahYesodi ? gNum(bituahYesodi, "ACHUZ-HAGDALAT-GAG-HATAM") : null),
      sugHatzmadaSchum: bituahYesodi ? lookup(SUG_HATZMADA, g(bituahYesodi, "SUG-HATZMADA-SCHUM-BITUAH")) : null,
      sugHatzmadaDmei:  bituahYesodi ? lookup(SUG_HATZMADA, g(bituahYesodi, "SUG-HATZMADA-DMEI-BITUAH")) : null,
      indKolelChisachon: bituahYesodi ? lookup(IND_YES_NO, g(bituahYesodi, "IND-SCHUM-BITUAH-KOLEL-CHISACHON")) : null,
      sugMaslulLebituah: bituahYesodi ? lookup(SUG_MASLUL_LEBITUAH, g(bituahYesodi, "SUG-MASLUL-LEBITUAH")) : null,
      misparMaskorot:    bituahYesodi ? gNum(bituahYesodi, "MISPAR-MASKOROT") : null,
      schumLeMaslul:     bituahYesodi ? gNum(bituahYesodi, "SCHUM-BITUACH-LEMASLUL") : null,
      achuzHaktzaaLeChisachon: bituahYesodi ? gNum(bituahYesodi, "ACHUZ-HAKTZAA-LE-CHISACHON") : null,
      // Additional insurance details
      sugMevutach:          kisui ? lookup(SUG_MEVUTACH, g(kisui, "SUG-MEVUTACH")) : null,
      kodNispach:           kisui ? g(kisui, "KOD-NISPACH-KISUY") : null,
      kodMutzarLakisuy:     kisui ? g(kisui, "KOD-MIUTZAR-LAKISUY") : null,
      sugIsuk:              kisui ? lookup(SUG_ISUK, g(kisui, "SUG-ISUK")) : null,
      kolelPrenzisa:        kisui ? lookup(IND_YES_NO, g(kisui, "KOLEL-PRENZISA")) : null,
      kolelSiud:            kisui ? lookup(IND_YES_NO, g(kisui, "KOLEL-SIUD")) : null,
      kitzbaZmudaLamadad:   kisui ? lookup(KITZBA_ZMUDA_LAMADAD, g(kisui, "KITZBA-ZMUDA-LAMADAD")) : null,
      nachutMitpatahat:     kisui ? lookup(NACHUT_MITPATAHAT, g(kisui, "NACHUT-MITPATAHAT")) : null,
      bitulKizuzMemshalti:  kisui ? lookup(IND_YES_NO, g(kisui, "BITUL-KIZUZ-MEMSHALTI")) : null,
      ofenTashlumSchum:     kisui ? lookup(OFEN_TASHLUM_SCHUM_BITUACH, g(kisui, "OFEN-TASHLUM-SCHUM-BITUACH")) : null,
      schumBituhKavoaMishtane: kisui ? lookup(KAVOA_MISHTANE, g(kisui, "SCHUM-BITUH-KAVOA-MISHTANE")) : null,
      sheurBituhKavoaMishtane: kisui ? lookup(KAVOA_MISHTANE, g(kisui, "SHEUR-BITUH-KAVOA-MISHTANE")) : null,
      meshalemHakisu:       kisui ? lookup(MESHALEM_HAKISUY, g(kisui, "MESHALEM-HAKISUY")) : null,
      kodIshun:             kisui ? lookup(IND_YES_NO, g(kisui, "KOD-ISHUN")) : null,
      indChitum:            kisui ? lookup(IND_YES_NO, g(kisui, "IND-CHITUM")) : null,
      taarichChitum:        kisui ? fmtDate(g(kisui, "TAARICH-CHITUM")) : null,
      hachraga:             kisui ? lookup(IND_YES_NO, g(kisui, "HACHRAGA")) : null,
      sugHachraga:          kisui ? g(kisui, "SUG-HACHRAGA") : null,
      tkufatAchshara:       kisui ? gNum(kisui, "TKUFAT-ACHSHARA") : null,
      tkufatHamtana:        kisui ? gNum(kisui, "TKUFAT-HAMTANA-CHODASHIM") : null,
      taarichIdkunDmeiBituah: kisui ? fmtDate(g(kisui, "TAARICH-IDKUN-HABA-SHEL-DMEI-HABITUAH")) : null,
      // Pension coverage details (KisuiBKerenPensia)
      alutNechut:     pensiaKisui ? gNum(pensiaKisui, "ALUT-KISUI-NECHUT") : null,
      alutSheerim:    pensiaKisui ? gNum(pensiaKisui, "ALUT-KISUY-SHEERIM") : null,
      alutPnsShrmNeche: pensiaKisui ? gNum(pensiaKisui, "ALUT-KISUI-PNS-SHRM-NECHE") : null,
      sheurNechut:    pensiaKisui ? gNum(pensiaKisui, "SHEUR-KISUY-NECHUT") : null,
      sheurSheerim:   pensiaKisui ? gNum(pensiaKisui, "SHIUR-KISUY-ALMAN-O-ALMANA") : null,
      sheurYatom:     pensiaKisui ? gNum(pensiaKisui, "SHIUR-KISUY-YATOM") : null,
      sheurHoreNitmach: pensiaKisui ? gNum(pensiaKisui, "SHIUR-KISUY-HORE-NITMACH") : null,
      sachPensiatNechut: pensiaKisui ? gNum(pensiaKisui, "SACH-PENSIAT-NECHUT") : null,
      kitzbatSheerim: pensiaKisui ? gNum(pensiaKisui, "KITZBAT-SHEERIM-LEALMAN-O-ALMANA") : null,
      kitzbatYatom:   pensiaKisui ? gNum(pensiaKisui, "KITZBAT-SHEERIM-LEYATOM") : null,
      kitzbatHoreNitmach: pensiaKisui ? gNum(pensiaKisui, "KITZBAT-SHEERIM-LEHORE-NITMACH") : null,
      sacharKoveaNechutSheerim: pensiaKisui ? gNum(pensiaKisui, "SACHAR-KOVEA-LE-NECHUT-VE-SHEERIM") : null,
      taarichMaskoretNechutSheerim: pensiaKisui ? fmtDate(g(pensiaKisui, "TAARICH-MASKORET-NECHUT-VE-SHEERIM")) : null,
      viturKisuyBituchi: pensiaKisui ? lookup(VITUR_KISUY_BITUCHI, g(pensiaKisui, "VITUR-KISUY-BITUCHI")) : null,
      sugVitorShaerim:   pensiaKisui ? lookup(SUG_VITOR_SHAERIM, g(pensiaKisui, "SUG-VITOR-SHAERIM")) : null,
      taarichViturSheerim: pensiaKisui ? fmtDate(g(pensiaKisui, "TAARICH-VITOR-SHEERIM")) : null,
      taarichSiumViturSheerim: pensiaKisui ? fmtDate(g(pensiaKisui, "TAARICH-CIUM-VITOR-SEERIM")) : null,
      nechutMitpatahatPensia: pensiaKisui ? lookup(NECHUT_MITPATAHAT_PENSIA, g(pensiaKisui, "NECHUT-MITPATAHAT") || g(pensiaKisui, "NACHUT-MITPATAHAT")) : null,
      hatavaBituchit: pensiaKisui ? lookup(IND_YES_NO, g(pensiaKisui, "HATAVA-BITUCHIT")) : null,
      gilPrishaKeren: pensiaKisui ? gNum(pensiaKisui, "GIL-PRISHA-LEPENSIYAT-ZIKNA") : null,
      menatPensia:    pensiaKisui ? gNum(pensiaKisui, "MENAT-PENSIA-TZVURA") : null,
      ahuzPensiyaTzvura: pensiaKisui ? gNum(pensiaKisui, "AHUZ-PENSIYA-TZVURA") : null,
      hodsheiHaverut: pensiaKisui ? gNum(pensiaKisui, "MISPAR-HODSHEI-HAVERUT-BEKEREN-HAPENSIYA") : null,
      hodsheiHaverutRetzufim: pensiaKisui ? gNum(pensiaKisui, "MISPAR-HODSHEI-HAVERUT-MITZ-BEKEREN-HAPENSIYA") : null,
      taarichTchilatHaverut: pensiaKisui ? fmtDate(g(pensiaKisui, "TAARICH-TCHILAT-HAVERUT")) : null,
      taarichErechLanetunim: pensiaKisui ? fmtDate(g(pensiaKisui, "TAARICH-ERECH-LANENTUNIM")) : null,
      mutav: mutavData,
      mevutach,
      miktsoa,
      // Future premium
      premiaZfoya: (function() {
        const pp = z.getElementsByTagName("hitpatchutpremia");
        if (!pp.length) return [];
        return Array.from(pp).map(p => ({
          from: g(p, "TCHILAT-TKUFA"),
          to:   g(p, "TOM-TKUFA"),
          amt:  gNum(p, "PREMIA-ZFOYA"),
        })).filter(p => p.amt);
      })(),
      // Projected sum insured over time (e.g. decreasing mortgage risk)
      schumZafuy: Array.from(z.getElementsByTagName("hitpatchutschusheurmbituh")).map(p => ({
        from:  g(p, "TCHILAT-TKUFA"),
        to:    g(p, "TOM-TKUFA"),
        schum: gNum(p, "SCHUM-BITUH-ZFOY"),
        sheur: gNum(p, "SHEUR-BITUH-ZFOY"),
      })).filter(p => p.schum || p.sheur),
      // Tiered discount schedule
      hanachaMedureget: Array.from(z.getElementsByTagName("hanachmedureget")).map(p => ({
        from:  g(p, "TCHILAT-TKUFA"),
        to:    g(p, "TOM-TKUFA"),
        sheur: gNum(p, "SHEUR-HANACHA"),
        schum: gNum(p, "SCHUM-HANACHA"),
      })).filter(p => p.sheur || p.schum),
    });
  }
  return covers;
}

// ── resolve current employer per policy ───────────────────────────────────────
// כל PirteiTaktziv בפוליסה = יחס עם מעסיק אחד. המעסיק הנוכחי נקבע לפי
// STATUS-MAASIK מהתקן (1=נוכחי, 2=קודם, 3=סה"כ קודמים); בקבצים אמיתיים השדה
// לעיתים nil — אז לפי ההפקדה האחרונה, ואז לפי תאריך תחילת תשלום.
function resolveEmployer(polisaEl, maasikInfoDict = {}) {
  const taktzivim = Array.from(polisaEl.getElementsByTagName("PirteiTaktziv"));

  const entries = taktzivim.map(t => {
    const oved    = t.getElementsByTagName("PirteiOved")[0] || null;
    const haasaka = t.getElementsByTagName("PirteiHaasaka")[0] || null;
    const mpr     = (oved ? g(oved, "MPR-MAASIK-BE-YATZRAN") : null) || g(t, "MPR-MAASIK-BE-YATZRAN");
    const status  = oved ? g(oved, "STATUS-MAASIK") : null;

    // ההפקדה האחרונה בתקציב הזה — מפתח השוואה YYYYMMDD; חודש שכר מנורמל לאמצע חודש
    let lastCmp = null, lastDisp = null;
    const consider = (raw, isMonth) => {
      const d = String(raw || "").replace(/\D/g, "");
      if (isMonth ? d.length < 6 : d.length < 8) return;
      const cmp = isMonth ? d.slice(0, 6) + "15" : d.slice(0, 8);
      if (!lastCmp || cmp > lastCmp) {
        lastCmp = cmp;
        lastDisp = fmtDate(isMonth ? d.slice(0, 6) : d.slice(0, 8));
      }
    };
    for (const d of Array.from(t.getElementsByTagName("PerutHafkadotMetchilatShana"))) {
      consider(g(d, "TAARICH-ERECH-HAFKADA"), false);
      consider(g(d, "CHODESH-SACHAR"), true);
    }
    for (const r of Array.from(t.getElementsByTagName("PerutPirteiHafkadaAchrona"))) {
      consider(g(r, "TAARICH-ERECH-HAFKADA"), false);
      consider(g(r, "TAARICH-HAFKADA-ACHARON"), true);
    }

    const gviaEl = t.getElementsByTagName("NetuneiGvia")[0];
    const info   = (mpr && maasikInfoDict[mpr]) || {};
    return {
      oved, haasaka, mpr, status,
      name:  info.name || (gviaEl ? g(gviaEl, "SHEM-MESHALEM") : null),
      id:    info.id || null,
      city:  info.city || null,
      phone: info.phone || null,
      startPay: (haasaka ? String(g(haasaka, "TAARICH-TCHILAT-TASHLUM") || "") : "").replace(/\D/g, ""),
      lastCmp, lastDisp,
    };
  }).filter(e => e.mpr || e.name);

  if (!entries.length) return { chosen: null, employer: null, employers: [] };

  // דירוג: STATUS-MAASIK=1 מנצח; ללא סטטוס עדיף על קודם (2/3); שוברי שוויון —
  // הפקדה אחרונה, ואז תחילת תשלום מאוחרת.
  const rank = e => (e.status === "1" ? 2 : (e.status === "2" || e.status === "3") ? 0 : 1);
  let chosen = entries[0];
  for (const e of entries.slice(1)) {
    if (rank(e) > rank(chosen)) { chosen = e; continue; }
    if (rank(e) < rank(chosen)) continue;
    const d1 = e.lastCmp || "", d0 = chosen.lastCmp || "";
    if (d1 > d0) { chosen = e; continue; }
    if (d1 === d0 && (e.startPay || "") > (chosen.startPay || "")) chosen = e;
  }

  const keyOf = e => `${e.mpr || ""}_${e.name || ""}`;
  const employers = [];
  const byKey = new Map();
  for (const e of entries) {
    const key = keyOf(e);
    const ex = byKey.get(key);
    if (ex) {
      // אותו מעסיק בכמה תקציבים — לשמור את ההפקדה האחרונה מביניהם
      if (e.lastCmp && (!ex._lastCmp || e.lastCmp > ex._lastCmp)) {
        ex._lastCmp = e.lastCmp;
        ex.lastDepositDate = e.lastDisp;
      }
      if (e.status === "1") { ex.status = "1"; ex.statusLabel = lookup(STATUS_MAASIK, "1"); }
      continue;
    }
    const row = {
      mpr: e.mpr, name: e.name, id: e.id, city: e.city, phone: e.phone,
      status: e.status,
      statusLabel: e.status ? lookup(STATUS_MAASIK, e.status) : null,
      startDate: fmtDate(e.startPay || null),
      lastDepositDate: e.lastDisp,
      _lastCmp: e.lastCmp,
      isCurrent: false,
    };
    byKey.set(key, row);
    employers.push(row);
  }
  const currentRow = byKey.get(keyOf(chosen));
  if (currentRow) currentRow.isCurrent = true;
  for (const row of employers) delete row._lastCmp;

  const employer = {
    name: chosen.name, id: chosen.id, city: chosen.city, phone: chosen.phone,
    mpr: chosen.mpr,
    status: chosen.status,
    // כשאין סימון מהתקן — לציין שהזיהוי נגזר מההפקדות
    statusLabel: chosen.status ? lookup(STATUS_MAASIK, chosen.status)
               : chosen.lastCmp ? "לפי הפקדה אחרונה" : null,
    startDate: fmtDate(chosen.startPay || null),
    lastDepositDate: chosen.lastDisp,
  };

  return { chosen, employer, employers };
}

// ── parse collection details (NetuneiGvia, under PirteiTaktziv) ──────────────
function parseGvia(polisaEl) {
  const rows = [];
  const els = polisaEl.getElementsByTagName("NetuneiGvia");
  for (let i = 0; i < els.length; i++) {
    const el = els[i];
    const row = {
      meshalem:        g(el, "SHEM-MESHALEM"),
      meshalemId:      g(el, "MISPAR-ZIHUY-MESHALEM"),
      sugTeuda:        lookup(SUG_TEUDA_MESHALEM, g(el, "SUG-TEUDA-MESHALEM")),
      emtzaeiTashlum:  lookup(KOD_EMTZAEI_TASHLUM, g(el, "KOD-EMTZAEI-TASHLUM")),
      tadirut:         lookup(TADIRUT_TASHLUM, g(el, "TADIRUT-TASHLUM")),
      chodeshYechus:   g(el, "CHODESH-YECHUS"),
      yomGviya:        gNum(el, "YOM-GVIYA-BECHODESH"),
      hatzmada:        lookup(OFEN_HATZMADAT_GVIA, g(el, "OFEN-HATZMADAT-GVIA")),
      achuzTatShnatiyot: gNum(el, "ACHUZ-TAT-SHNATIYOT"),
    };
    if (Object.values(row).some(v => v !== null && v !== undefined)) rows.push(row);
  }
  return rows;
}

// ── parse claims (PirteyTvia) ─────────────────────────────────────────────────
function parseTviot(polisaEl) {
  const rows = [];
  const els = polisaEl.getElementsByTagName("PirteyTvia");
  for (let i = 0; i < els.length; i++) {
    const el = els[i];
    if (g(el, "YESH-TVIA") !== "1") continue;
    rows.push({
      misparTvia:   g(el, "MISPAR-TVIA-BE-YATZRAN"),
      misparKisui:  g(el, "MISPAR-KISUI-BE-YATZRAN"),
      shemKisui:    g(el, "SHEM-KISUI-BE-YATZRAN"),
      sugTvia:      lookup(SUG_HATVIAA, g(el, "SUG-HATVIAA")),
      ofenTashlum:  lookup(OFEN_TASHLUM_TVIA, g(el, "OFEN-TASHLUM")),
      status:       lookup(KOD_STATUS_TVIA, g(el, "KOD-STATUS-TVIAA")),
      statusDate:   fmtDate(g(el, "TAARICH-STATUS-TVIA")),
      startPayDate: fmtDate(g(el, "TAARICH-TECHILAT-TASHLUM")),
      achuzOka:     gNum(el, "ACHUZ-MEUSHAR-O-K-A-SHICHRUR"),
      schumMeushar: gNum(el, "SCHUM-TVIA-MEUSHAR"),
      achuzNechut:  gNum(el, "ACHUZ-NECHUT"),
    });
  }
  return rows;
}

// ── parse collective umbrella coverages (PerutMitryot) ───────────────────────
function parseMitriyot(polisaEl) {
  const rows = [];
  const els = polisaEl.getElementsByTagName("PerutMitryot");
  for (let i = 0; i < els.length; i++) {
    const el = els[i];
    if (g(el, "KAYAM-KISUY-BITUCHI-COLECTIVI-LEAMITIM") === "2") continue;
    const row = {
      mevatachat:   g(el, "SHEM-MEVATACHAT"),
      startDate:    fmtDate(g(el, "TAARICH-TCHILAT-HABITUACH")),
      endDate:      fmtDate(g(el, "TAARICH-TOM-TKUFAT-HABITUAH")),
      sugMutzar:    lookup(KOD_SUG_MUTZAR_BITUACH, g(el, "KOD-SUG-MUTZAR-BITUACH")),
      schum:        gNum(el, "SCHUM-BITUACH"),
      alut:         gNum(el, "ALUT-KISUI"),
      meshalem:     lookup(MESHALEM_DMEI_HABITUAH_MITRIYA, g(el, "MESHALEM-DMEI-HABITUAH")),
      tadirut:      lookup(TADIRUT_HATSHLUM_MITRIYA, g(el, "TADIRUT-HATSHLUM")),
      nechtamTofes: lookup(IND_YES_NO, g(el, "HAIM-NECHTAM-TOFES-HITZTARFUT")),
    };
    if (Object.values(row).some(v => v !== null && v !== undefined)) rows.push(row);
  }
  return rows;
}

// ── parse retirement projections ──────────────────────────────────────────────
function parseRetirementProjections(polisaEl) {
  const projections = [];
  const els = polisaEl.getElementsByTagName("YitraLefiGilPrisha");
  for (let i = 0; i < els.length; i++) {
    const y = els[i];
    const gilPrisha = gNum(y, "GIL-PRISHA");
    const kupot = y.getElementsByTagName("Kupa");
    const kupotData = Array.from(kupot).map(k => ({
      sugKupa:      lookup(SUG_KUPA, g(k, "SUG-KUPA")),
      pension:      gNum(k, "SCHUM-KITZVAT-ZIKNA"),
      pensionMonthly: gNum(k, "KITZVAT-HODSHIT-TZFUYA"),
      tsua:         gNum(k, "ACHUZ-TSUA-BATACHAZIT"),
      totalSavings: gNum(k, "TOTAL-SCHUM-MTZBR-TZAFUY-LEGIL-PRISHA-MECHUSHAV-LEKITZBA-IM-PREMIYOT"),
      totalSavingsNoPrem: gNum(k, "TOTAL-SCHUM-MITZVTABER-TZFUY-LEGIL-PRISHA-MECHUSHAV-HAMEYOAD-LEKITZBA-LELO-PREMIYOT"),
    }));
    projections.push({
      age:          gilPrisha,
      totalSavings: gNum(y, "TOTAL-CHISACHON-MITZTABER-TZAFUY"),
      totalSavingsNoPrem: gNum(y, "TZVIRAT-CHISACHON-CHAZUYA-LELO-PREMIYOT"),
      mekadem:      gNum(y, "MEKADEM-MOVTACH-LEPRISHA"),
      shem_maslol:  g(y, "SHEM-MASLOL"),
      sheurPensiaZikna: gNum(y, "SHEUR-PNS-ZIKNA-TZFUYA"),
      kupot: kupotData,
    });
  }
  return projections;
}

// ── parse balances ────────────────────────────────────────────────────────────
function parseYitrot(polisaEl, maasikDict = {}) {
  const blockEls = polisaEl.getElementsByTagName("BlockItrot");
  if (!blockEls.length) return null;

  let balDate = null;
  let tagmulimLiquidity = null;
  let tagmulimBalance = 0;
  let tikratHafkada = null;
  
  const allPerut = [];
  const allPerPeriod = [];
  
  const pitzuyimSums = {
    pitzuyimPturim: 0,
    pitzuyimLekitzba: 0,
    pitzuyimBeretzefKitzba: 0,
    pitzuyimBeretzefZechuyot: 0,
    pitzuyim1999: 0,
    erkeiPitzuimMaasik: 0,
    erkeiPitzuyimMas: 0,
    erkeiRetzefZehuyut: 0,
    erkeiLehon: 0,
    yitratPitzuim: 0,
    retzefKitzba: "",
    retzefZechuyot: "",
  };
  let hasPitzuyim = false;

  for (let i = 0; i < blockEls.length; i++) {
    const blockEl = blockEls[i];
    // MPR-MAASIK-BE-YATZRAN is on the parent PirteiTaktziv, not inside BlockItrot
    const pirteiTaktziv = blockEl.parentNode;
    const maasikCode = g(pirteiTaktziv, "MPR-MAASIK-BE-YATZRAN");
    const mName = maasikDict[maasikCode] || null;

    const yitrotEl = blockEl.getElementsByTagName("Yitrot")[0];
    if (!yitrotEl) continue;

    if (!balDate) balDate = g(yitrotEl, "TAARICH-ERECH-TZVIROT");

    const pArr = Array.from(yitrotEl.getElementsByTagName("PerutYitrot")).map(p => ({
      sugItra:    g(p, "KOD-SUG-ITRA"),
      sugHafrasha: lookup(SUG_HAFRASHA, g(p, "KOD-SUG-HAFRASHA")),
      balance:    gNum(p, "TOTAL-CHISACHON-MTZBR"),
      redeem:     gNum(p, "TOTAL-ERKEI-PIDION"),
      maasikName: mName,
    }));
    allPerut.push(...pArr);

    const ppArr = Array.from(yitrotEl.getElementsByTagName("PerutYitraLeTkufa")).map(p => ({
      shichva:       g(p, "KOD-TECHULAT-SHICHVA"),
      rekiv:         g(p, "REKIV-ITRA-LETKUFA"),
      sugItra:       g(p, "SUG-ITRA-LETKUFA"),
      tikratHafkada: g(p, "TIKRAT-HAFKADA-MUTEVET"),
      amount:        gNum(p, "SACH-ITRA-LESHICHVA-BESHACH"),
      maasikName:    mName,
    }));
    allPerPeriod.push(...ppArr);

    const shonot = yitrotEl.getElementsByTagName("YitrotShonot")[0];
    if (shonot) {
      hasPitzuyim = true;
      pitzuyimSums.pitzuyimPturim += gNum(shonot, "TZVIRAT-PITZUIM-PTURIM-MAAVIDIM-KODMIM") || 0;
      pitzuyimSums.pitzuyimLekitzba += gNum(shonot, "ERECH-PIDION-PITZUIM-LEKITZBA-MAAVIDIM-KODMIM") || 0;
      pitzuyimSums.pitzuyimBeretzefKitzba += gNum(shonot, "TZVIRAT-PITZUIM-MAAVIDIM-KODMIM-BERETZEF-KITZBA") || 0;
      pitzuyimSums.pitzuyimBeretzefZechuyot += gNum(shonot, "TZVIRAT-PITZUIM-MAAVIDIM-KODMIM-BERETZEF-ZECHUYOT") || 0;
      pitzuyimSums.pitzuyim1999 += gNum(shonot, "TZVIRAT-PITZUIM-31-12-1999-LEKITZBA") || 0;
      pitzuyimSums.erkeiPitzuimMaasik += gNum(shonot, "ERECH-PIDION-PITZUIM-MAASIK-NOCHECHI") || 0;
      pitzuyimSums.erkeiPitzuyimMas += gNum(shonot, "ERECH-PIDION-MARKIV-PITZUIM-LEMAS-NOCHECHI") || 0;
      pitzuyimSums.erkeiRetzefZehuyut += gNum(shonot, "ERECH-PIDION-PITZUIM-MAAVIDIM-KODMIM-RETZEF-ZEHUYUT") || 0;
      pitzuyimSums.erkeiLehon += gNum(shonot, "ERECH-PIDION-PITZUIM-LEHON-MAAVIDIM-KODMIM") || 0;
      pitzuyimSums.yitratPitzuim += gNum(shonot, "YITRAT-PITZUIM-LELO-HITCHASHBENOT") || 0;
      if (!pitzuyimSums.retzefKitzba) pitzuyimSums.retzefKitzba = g(shonot, "KAYAM-RETZEF-PITZUIM-KITZBA");
      if (!pitzuyimSums.retzefZechuyot) pitzuyimSums.retzefZechuyot = g(shonot, "KAYAM-RETZEF-ZECHUYOT-PITZUIM");
    }

    const nesilut = yitrotEl.getElementsByTagName("NesilutTag")[0];
    if (nesilut) {
      if (!tagmulimLiquidity) tagmulimLiquidity = fmtDate(g(nesilut, "MOED-NEZILUT-TAGMULIM"));
      tagmulimBalance += gNum(nesilut, "YITRAT-KASPEY-TAGMULIM") || 0;
    }

    if (!tikratHafkada) {
      const pp = yitrotEl.getElementsByTagName("PerutYitraLeTkufa")[0];
      if (pp) tikratHafkada = g(pp, "TIKRAT-HAFKADA-MUTEVET");
    }
  }

  return {
    raw: {
      KAYAM_RETZEF_PITZUIM_KITZBA: pitzuyimSums.retzefKitzba,
      KAYAM_RETZEF_ZECHUYOT_PITZUIM: pitzuyimSums.retzefZechuyot,
      TZVIRAT_PITZUIM_MAAVIDIM_KODMIM_BERETZEF_ZECHUYOT: pitzuyimSums.pitzuyimBeretzefZechuyot,
      TZVIRAT_PITZUIM_31_12_1999_LEKITZBA: pitzuyimSums.pitzuyim1999,
      ERECH_PIDION_PITZUIM_MAAVIDIM_KODMIM_RETZEF_ZEHUYUT: pitzuyimSums.erkeiRetzefZehuyut,
      ERECH_PIDION_PITZUIM_LEHON_MAAVIDIM_KODMIM: pitzuyimSums.erkeiLehon,
    },
    date: fmtDate(balDate),
    perut: allPerut,
    perPeriod: allPerPeriod,
    pitzuyim: hasPitzuyim ? {
      ...pitzuyimSums
    } : null,
    tagmulimLiquidity,
    tagmulimBalance: tagmulimBalance > 0 ? tagmulimBalance : null,
    tikratHafkada: tikratHafkada || null,
    totalRedeem: allPerPeriod.length > 0
      ? allPerPeriod.reduce((s, p) => s + (p.amount || 0), 0)
      : allPerut.reduce((s, p) => s + (p.redeem || 0), 0),
    totalBalance: allPerut.reduce((s, p) => s + (p.balance || 0), 0),
  };
}

// ── parse annual deposits ─────────────────────────────────────────────────────
function parseAnnualDeposits(polisaEl) {
  const h = polisaEl.getElementsByTagName("HafkadotShnatiyot")[0];
  if (!h) return null;
  return {
    oved:    gNum(h, "TOTAL-HAFKADOT-OVED-TAGMULIM-SHANA-NOCHECHIT"),
    maavid:  gNum(h, "TOTAL-HAFKADOT-MAAVID-TAGMULIM-SHANA-NOCHECHIT"),
    pitzuim: gNum(h, "TOTAL-HAFKADOT-PITZUIM-SHANA-NOCHECHIT"),
  };
}

// ── parse dated cash flows (deposits + transfers/withdrawals) ────────────────
// Used for monthly Modified-Dietz return: each flow carries its value-date so it
// can be filtered to the interval between two monthly snapshots and day-weighted.
function isoDate(yyyymmdd) {
  const s = String(yyyymmdd || "").replace(/\D/g, "");
  if (s.length < 8) return null;
  return `${s.slice(0, 4)}-${s.slice(4, 6)}-${s.slice(6, 8)}`;
}

// YYYYMM (CHODESH-SACHAR / MOED-KOVEA-NIUD) → ISO date of the last day of that month.
// Used as a value-date fallback so a one-time / transfer deposit with a missing
// TAARICH-ERECH-HAFKADA still lands inside the right monthly interval and is netted.
function endOfMonthIso(yyyymm) {
  const s = String(yyyymm || "").replace(/\D/g, "");
  if (s.length < 6) return null;
  const y = Number(s.slice(0, 4));
  const m = Number(s.slice(4, 6));
  if (!y || !m || m > 12) return null;
  const last = new Date(y, m, 0).getDate(); // day 0 of next month = last day of this month
  return `${s.slice(0, 4)}-${s.slice(4, 6)}-${String(last).padStart(2, "0")}`;
}

// שם המעסיק של תנועה: עולים בהיררכיה עד האב הנושא MPR-MAASIK-BE-YATZRAN (ילד ישיר)
// ופותרים מול מילון המעסיקים. בדומה לאופן שבו נפתר מעסיק ליתרות.
function maasikNameForFlow(el, maasikDict) {
  let node = el.parentNode;
  while (node && node.tagName) {
    const codeEl = Array.from(node.childNodes || []).find(c => c.tagName === "MPR-MAASIK-BE-YATZRAN");
    const code = codeEl?.textContent?.trim();
    if (code) return maasikDict[code] || null;
    node = node.parentNode;
  }
  return null;
}

function parseFlows(polisaEl, maasikDict = {}) {
  // Deposits — dated rows under PerutHafkadotMetchilatShana
  const deposits = [];
  const depEls = polisaEl.getElementsByTagName("PerutHafkadotMetchilatShana");
  for (let i = 0; i < depEls.length; i++) {
    const d = depEls[i];
    const amount = gNum(d, "SCHUM-HAFKADA-SHESHULAM");
    if (!amount) continue; // a 0 / empty amount contributes nothing — skip only that
    // A row carrying a transferring-fund id/name is an incoming ניוד (one-time movement).
    const isTransfer = !!(g(d, "KOD-MEZAHE-KOPA-MAAVIRA") || g(d, "SHEM-KOPA-MAAVIRA"));
    // Never drop the flow for a missing value-date: fall back so it is still netted.
    const valueDate =
      isoDate(g(d, "TAARICH-ERECH-HAFKADA")) ||
      endOfMonthIso(g(d, "MOED-KOVEA-NIUD")) ||
      endOfMonthIso(g(d, "CHODESH-SACHAR"));
    const sugMafkid = g(d, "SUG-MAFKID");
    deposits.push({
      amount,
      valueDate,
      dateRaw: fmtDate(g(d, "TAARICH-ERECH-HAFKADA")),
      chodeshSachar: g(d, "CHODESH-SACHAR") || null,
      sugHafrasha: g(d, "SUG-HAFRASHA"),
      type: lookup(SUG_HAFRASHA, g(d, "SUG-HAFRASHA")),
      sugMafkid,
      payer: lookup(SUG_MAFKID, sugMafkid),
      kodSugHafkada: g(d, "KOD-SUG-HAFKADA"),
      salary: gNum(d, "SACHAR-BERAMAT-HAFKADA") || null,
      maasik: maasikNameForFlow(d, maasikDict) || (g(d, "SHEM-KOPA-MAAVIRA") || null),
      depositType: isTransfer ? "ניוד כספים" : "שוטפת",
      isTransfer,
    });
  }

  // Transfers out / withdrawals — MeshichaNiud (often empty)
  const withdrawals = [];
  const wEls = polisaEl.getElementsByTagName("MeshichaNiud");
  for (let i = 0; i < wEls.length; i++) {
    const w = wEls[i];
    const amount = gNum(w, "SCHOOM-MESHICHA-NIUD") || gNum(w, "SCHUM-MESHICHA-NIUD");
    if (!amount) continue;
    const kodPeula = g(w, "KOD-SUG-PEULA");
    withdrawals.push({
      amount,
      valueDate: isoDate(g(w, "TAARICH-ERECH") || g(w, "TAARICH-BIZOA") || g(w, "TAARICH-MESHICHA")),
      kind: lookup(KOD_SUG_PEULA, kodPeula),
    });
  }

  return { deposits, withdrawals };
}

// ── parse debts ───────────────────────────────────────────────────────────────
function parseDebts(polisaEl) {
  const el = polisaEl.getElementsByTagName("ChovPigur")[0];
  if (!el) return null;
  const hasDebt = g(el, "KAYAM-CHOV-O-PIGUR") === "1";
  if (!hasDebt) return null;
  return {
    startDate:   fmtDate(g(el, "TAARICH-TECHILAT-PIGUR")),
    months:      gNum(el, "MISPAR-CHODSHEI-PIGUR"),
    sugHov:      lookup(SUG_HOV, g(el, "SUG-HOV")),
    totalDebt:   gNum(el, "TOTAL-CHOVOT-O-PIGURIM"),
    unallocated: gNum(el, "KSAFIM-LO-MESHUYACHIM-MAASIK"),
  };
}

// ── parse management fees structure ──────────────────────────────────────────
function parseDmeiNihul(polisaEl) {
  const allActuals = Array.from(polisaEl.getElementsByTagName("HotzaotBafoalLehodeshDivoach"));
  const allMivnes = Array.from(polisaEl.getElementsByTagName("MivneDmeiNihul"));

  const structure = allMivnes.flatMap(mivne => 
    Array.from(mivne.getElementsByTagName("PerutMivneDmeiNihul")).map(m => ({
      sugHotzaa:  g(m, "SUG-HOTZAA"),
      meafyenei:  g(m, "MEAFYENEI-MASLUL-DMEI-NIHUL"),
      dmeiPct:    gNum(m, "SHEUR-DMEI-NIHUL"),
      updateDate: fmtDate(g(m, "TAARICH-IDKUN-SHEUR-DNHL")),
      hatava:     g(m, "KAYEMET-HATAVA") === "1",
      hatavaAmt:  gNum(m, "ACHOZ-HATAVA"),
      hatavaEnd:  fmtDate(g(m, "TAARICH-SIUM-HATAVA")),
    }))
  );

  // SHEUR-DMEI-NIHUL-TZVIRA in HotzaotBafoal is the MONTHLY rate (per Excel schema row 401).
  // The correct annual rates come from MivneDmeiNihul (SHEUR-DMEI-NIHUL):
  //   SUG-HOTZAA=1 → מצבירה (annual accumulation rate)
  //   SUG-HOTZAA=2 → מהפקדה (annual deposit rate)
  // MEAFYENEI-MASLUL-DMEI-NIHUL values (per Excel schema row 418):
  //   1 = שיעור קבוע (fixed rate — the base accumulation %)
  //   6 = פוליסות משתתפות עד 2004 (old participating policies — % from profits, NOT from accumulation)
  // For MEAFYENEI=6, the % is from profits, so we must NOT include it in the regular accumulation rate
  const tzvFixed  = structure.filter(s => s.sugHotzaa === "1" && s.meafyenei !== "6" && s.dmeiPct > 0);
  const tzvProfit = structure.filter(s => s.sugHotzaa === "1" && s.meafyenei === "6" && s.dmeiPct > 0);
  const hafRows   = structure.filter(s => s.sugHotzaa === "2" && s.dmeiPct > 0);
  const annualTzvPct    = tzvFixed.length  ? Math.max(...tzvFixed.map(s => s.dmeiPct))  : null;
  const profitSharePct  = tzvProfit.length ? Math.max(...tzvProfit.map(s => s.dmeiPct)) : null;
  const annualHafPct    = hafRows.length   ? Math.max(...hafRows.map(s => s.dmeiPct))   : null;

  if (allActuals.length === 0) {
    return { actual: null, structure };
  }

  // Aggregate totals across all actuals
  let dmeiHafAmt = 0, dmeiTzvAmt = 0, dmeiAchrim = 0, total = 0, dmeiNiulMenael = 0;
  for (const act of allActuals) {
    dmeiHafAmt += gNum(act, "TOTAL-DMEI-NIHUL-HAFKADA");
    dmeiTzvAmt += gNum(act, "TOTAL-DMEI-NIHUL-TZVIRA");
    dmeiAchrim += gNum(act, "SACH-DMEI-NIHUL-ACHERIM");
    total += gNum(act, "TOTAL-DMEI-NIHUL-POLISA-O-HESHBON");
    dmeiNiulMenael += gNum(act, "DMEI-NIUL-MENAEL-TIKIM");
  }

  return {
    actual: {
      dmeiHafPct:     annualHafPct > 0 ? annualHafPct : null,
      dmeiHafAmt,
      dmeiTzvPct:     annualTzvPct > 0 ? annualTzvPct : null,
      dmeiTzvAmt,
      profitSharePct,
      dmeiAchrim,
      total,
      // For averages, just take the first one or null since it's rarely used
      avgHafPct:      allActuals[0] ? gNum(allActuals[0], "MEMOTZA-SHEUR-DMEI-NIHUL-HAFKADA") : 0,
      avgHafAmt:      allActuals[0] ? gNum(allActuals[0], "MEMOTZA-TOTAL-DMEI-NIHUL-HAFKADA") : 0,
      dmeiNiulMenael,
    },
    structure,
  };
}

// ── parse loans ───────────────────────────────────────────────────────────────
// Halvaa הוא maxOccurs="unbounded" בסכמה — יכולות להיות כמה הלוואות על פוליסה
function parseLoans(polisaEl) {
  return Array.from(polisaEl.getElementsByTagName("Halvaa"))
    .filter(h => g(h, "YESH-HALVAA-BAMUTZAR") === "1")
    .map(h => ({
      amount:          gNum(h, "SCHUM-HALVAA"),
      balance:         gNum(h, "YITRAT-HALVAA"),
      startDate:       fmtDate(g(h, "TAARICH-KABALAT-HALVAA")),
      endDate:         fmtDate(g(h, "TAARICH-SIYUM-HALVAA")),
      period:          gNum(h, "TKUFAT-HALVAA"),
      interest:        gNum(h, "RIBIT"),
      frequency:       g(h, "TADIRUT-HECHZER-HALVAA"),
      refNum:          g(h, "MISDAR-SIDURI-SHEL-HAHALVAA"),
      level:           g(h, "RAMAT-HALVAA"),          // 1=פוליסה ספציפית 2=כל הפוליסות
      interestType:    g(h, "SUG-RIBIT"),             // 1=קבועה 2=משתנה
      indexation:      g(h, "SUG-HATZNMADA"),         // 1=לא צמוד 2=מדד חודשי 3=מדד חצי שנתי 4=אחר
      repayType:       g(h, "SUG-HECHZER"),           // 1=שפיצר 2=ריבית שוטפת
      periodicPayment: gNum(h, "SCHUM-HECHZER-TKUFATI"),
    }));
}

// ── parse last deposit ────────────────────────────────────────────────────────
function parseLastDeposit(polisaEl) {
  const el = polisaEl.getElementsByTagName("PirteiHafkadaAchrona")[0];
  if (!el) return null;
  const rows = Array.from(el.getElementsByTagName("PerutPirteiHafkadaAchrona")).map(r => {
    // SUG-HAFKADA ברמת השורה: 1=שוטפת, 2=חד פעמית, 3=ניוד כספים. רק "שוטפת" נספרת
    // כהפקדה חודשית בהקרנה. ערך חסר נחשב שוטפת (תאימות לאחור).
    const sugHafkada = g(r, "SUG-HAFKADA");
    const isRecurring = sugHafkada !== "2" && sugHafkada !== "3";
    return {
    period:   g(r, "TAARICH-HAFKADA-ACHARON"),
    total:    gNum(r, "TOTAL-HAFKADA"),
    date:     fmtDate(g(r, "TAARICH-ERECH-HAFKADA")),
    sugHafkada,
    isRecurring,
    breakdown: Array.from(r.getElementsByTagName("PerutHafkadaAchrona")).map(b => {
      const sugMafkid = g(b, "SUG-MAFKID");
      return {
        sugHafkada:  g(b, "KOD-SUG-HAFKADA"),
        sugHafrasha: lookup(SUG_HAFRASHA, g(b, "SUG-HAFRASHA")),
        sugMafkid,
        payer:       lookup(SUG_MAFKID, sugMafkid),
        salary:      gNum(b, "SACHAR-BERAMAT-HAFKADA"),
        amount:      gNum(b, "SCHUM-HAFKADA-SHESHULAM"),
        // ניוד כספים (SUG-MAFKID=6) — לא הפקדה שוטפת; להגנה גם בדיקת קופה מעבירה
        isTransfer:  sugMafkid === "6"
                     || !!(g(b, "KOD-MEZAHE-KOPA-MAAVIRA") || g(b, "SHEM-KOPA-MAAVIRA")),
      };
    }),
    };
  });
  return rows.length ? rows : null;
}

// ── MAIN PARSER ───────────────────────────────────────────────────────────────
export function parseXMLFiles(xmlContents) {
  const allFunds = [];
  const parser = new DOMParser();
  const seen = new Set();

  let taarichBitzua = null;
  let sugMimshak = null; // 1=ממשק אחזקות, 2=טרום ייעוץ, 3=שניהם

  for (const { name, content } of xmlContents) {
    let doc;
    try {
      doc = parser.parseFromString(content, "application/xml");
    } catch (e) {
      console.warn("Parse error in", name, e);
      continue;
    }

    const koteret = doc.getElementsByTagName("KoteretKovetz")[0];
    if (koteret) {
      if (!taarichBitzua) {
        const raw = g(koteret, "TAARICH-BITZUA");
        if (raw) taarichBitzua = fmtDate(raw.slice(0, 8));
      }
      if (!sugMimshak) {
        const sm = g(koteret, "SUG-MIMSHAK");
        if (sm) sugMimshak = String(sm).trim();
      }
    }

    const yatzranim = doc.getElementsByTagName("YeshutYatzran");
    for (let yi = 0; yi < yatzranim.length; yi++) {
      const yatzran = yatzranim[yi];
      const companyName = shortenCompanyName(g(yatzran, "SHEM-YATZRAN"));
      const companyCode = g(yatzran, "KOD-MEZAHE-YATZRAN");

      const mutzarim = yatzran.getElementsByTagName("Mutzar");
      for (let mi = 0; mi < mutzarim.length; mi++) {
        const mutzar = mutzarim[mi];
        const sugMutzar = g(mutzar, "SUG-MUTZAR");

        // Client
        const lakoach = mutzar.getElementsByTagName("YeshutLakoach")[0];
        const client = lakoach ? {
          id:       String(g(lakoach, "MISPAR-ZIHUY-LAKOACH") || "").padStart(9, "0").slice(-9),
          name:     `${g(lakoach, "SHEM-PRATI") || ""} ${g(lakoach, "SHEM-MISHPACHA") || ""}`.trim(),
          bday:     fmtDate(g(lakoach, "TAARICH-LEYDA")),
          gender:   lookup(MIN, g(lakoach, "MIN")),
          city:     g(lakoach, "SHEM-YISHUV"),
          street:   g(lakoach, "SHEM-RECHOV"),
          houseNum: g(lakoach, "MISPAR-BAIT"),
          zip:      g(lakoach, "MIKUD"),
          phone:    g(lakoach, "MISPAR-TELEPHONE-KAVI"),
          mobile:   g(lakoach, "MISPAR-CELLULARI"),
          email:    g(lakoach, "E-MAIL"),
          marital:  lookup(MATZAV_MISHPACHTI, g(lakoach, "MATZAV-MISHPACHTI")),
          children: gNum(lakoach, "MISPAR-YELADIM"),
          ptira:       g(lakoach, "PTIRA") === "1",
          taarichPtira: fmtDate(g(lakoach, "TAARICH-PTIRA")),
        } : null;

        // Employer dictionaries for current mutzar (MPR → name / full details).
        // אותו MPR יכול להופיע בכמה YeshutMaasik — שומרים את הראשון עם שם.
        const maasikDict = {};
        const maasikInfoDict = {};
        const allMaasikEls = mutzar.getElementsByTagName("YeshutMaasik");
        for (let idx = 0; idx < allMaasikEls.length; idx++) {
          const el = allMaasikEls[idx];
          const code = g(el, "MPR-MAASIK-BE-YATZRAN");
          if (!code) continue;
          maasikDict[code] = g(el, "SHEM-MAASIK");
          if (!maasikInfoDict[code] || (!maasikInfoDict[code].name && g(el, "SHEM-MAASIK"))) {
            maasikInfoDict[code] = {
              name:  g(el, "SHEM-MAASIK"),
              id:    g(el, "MISPAR-MEZAHE-MAASIK"),
              city:  g(el, "SHEM-YISHUV"),
              phone: g(el, "MISPAR-TELEPHONE-KAVI"),
            };
          }
        }

        // fallback בלבד — כשאין בפוליסה שום PirteiTaktziv עם מעסיק (התנהגות ישנה)
        const maasikEl = allMaasikEls[0];
        const mutzarEmployer = maasikEl ? {
          name: g(maasikEl, "SHEM-MAASIK"),
          id:   g(maasikEl, "MISPAR-MEZAHE-MAASIK"),
          city: g(maasikEl, "SHEM-YISHUV"),
          phone: g(maasikEl, "MISPAR-TELEPHONE-KAVI"),
        } : null;

        const polisot = mutzar.getElementsByTagName("HeshbonOPolisa");
        for (let pi = 0; pi < polisot.length; pi++) {
          const p = polisot[pi];
          const polNum   = g(p, "MISPAR-POLISA-O-HESHBON");
          const kidodAchid = g(p, "KIDOD-ACHID") || "";
          const dedupeKey = `${companyCode}_${polNum}_${kidodAchid}`;
          if (seen.has(dedupeKey)) continue;
          seen.add(dedupeKey);

          // Agent
          const meyupeEl = p.getElementsByTagName("PerutMeyupeKoach")[0];
          const agent = meyupeEl && g(meyupeEl, "KAYAM-MEYUPE-KOACH") === "1" ? {
            name:      g(meyupeEl, "SHEM-MEYUPE-KOACH"),
            id:        g(meyupeEl, "MISPAR-ZIHUY"),
            number:    g(meyupeEl, "MPR-MEFITZ-BE-YATZRAN") || g(p, "MPR-MEFITZ-BE-YATZRAN"),
            startDate: fmtDate(g(meyupeEl, "TAARICH-MINUY-SOCHEN")),
            endDate:   fmtDate(g(meyupeEl, "TAARICH-TOM-TOKEF-YEPUI-KOACH")),
          } : null;

          // Current employer — resolved per policy from its PirteiTaktziv blocks
          const empRes = resolveEmployer(p, maasikInfoDict);

          // Employment details — מהתקציב של המעסיק הנוכחי, לא סתם מהראשון
          const pirteiOved = empRes.chosen?.oved || p.getElementsByTagName("PirteiOved")[0];
          const pirteiHaasaka = empRes.chosen?.haasaka || p.getElementsByTagName("PirteiHaasaka")[0];
          const rawSugTochnit = pirteiOved ? g(pirteiOved, "SUG-TOCHNIT-O-CHESHBON") : g(p, "SUG-TOCHNIT-O-CHESHBON");
          const employment = {
            sugTochnit:     lookup(SUG_TOCHNIT, rawSugTochnit),
            sugTochnitCode: rawSugTochnit ?? null,
            salary:     pirteiHaasaka ? gNum(pirteiHaasaka, "SACHAR-POLISA") : null,
            salaryCalcMethod: pirteiHaasaka ? lookup(KOD_CHISHUV_SACHAR, g(pirteiHaasaka, "KOD-CHISHUV-SACHAR-POLISA-O-HESHBON")) : null,
            salaryDate: pirteiHaasaka ? fmtDate(g(pirteiHaasaka, "TAARICH-MASKORET")) : null,
            startDate:  pirteiHaasaka ? fmtDate(g(pirteiHaasaka, "TAARICH-TCHILAT-TASHLUM")) : null,
            seif14:     pirteiHaasaka ? lookup(SEIF_14, g(pirteiHaasaka, "SEIF-14")) : null,
          };

          // Returns
          const tsuaEl = p.getElementsByTagName("Tsua")[0];
          const returns = tsuaEl ? {
            neto:     gNum(tsuaEl, "SHEUR-TSUA-NETO"),
            bruto1:   gNum(tsuaEl, "SHEUR-TSUA-BRUTO-CHS-1"),
            bruto2:   gNum(tsuaEl, "ACHUZ-TSUA-BRUTO-CHS-2"),
            guaranteed: gNum(tsuaEl, "ACHUZ-TSUA-MUVTAHT"),
            profitLoss: gNum(tsuaEl, "REVACH-HEFSED-BENIKOI-HOZAHOT"),
          } : null;

          // Previous year
          const prevEl = p.getElementsByTagName("PerutYitrotLesofShanaKodemet")[0];
          const prevYear = prevEl ? gNum(prevEl, "YITRAT-SOF-SHANA") : null;

          // Yitrot (balances)
          const yitrot = parseYitrot(p, maasikDict);

          // Main data
          const statusLabel = lookup(STATUS_POLISA, g(p, "STATUS-POLISA-O-CHESHBON"));
          const cat = SUG_MUTZAR_CATEGORY[sugMutzar] || "ביטוח מנהלים";
          const redeem = yitrot?.totalRedeem || 0;
          const loans = parseLoans(p);

          allFunds.push({
            // Identity
            id:          dedupeKey,
            sourceFile:  name,
            companyName, companyCode,
            sugMutzar,
            mugName:     SUG_MUTZAR[sugMutzar] || sugMutzar,
            cat,
            icon:        SUG_MUTZAR_ICON[sugMutzar] || "📋",
            polNum,
            tochnit:     g(p, "SHEM-TOCHNIT"),
            kidodAchid:  g(p, "KIDOD-ACHID"),
            statusCode:  g(p, "STATUS-POLISA-O-CHESHBON"),
            statusLabel,
            joinDate:    fmtDate(g(p, "TAARICH-HITZTARFUT-MUTZAR")),
            firstJoinDate: fmtDate(g(p, "TAARICH-HITZTARFUT-RISHON")),
            validDate:   fmtDate(g(p, "TAARICH-NECHONUT")),
            statusUpdateDate: fmtDate(g(p, "TAARICH-IDKUN-STATUS")),
            madad:       gNum(p, "MADAD-BASIS"),
            tikun190:    lookup(TIKUN_190, g(p, "TIKUN-190")),
            pensiaVatika: lookup(PENSIA_VATIKA, g(p, "PENSIA-VATIKA-O-HADASHA")),
            sugKerenPensia: lookup(SUG_KEREN_PENSIA, g(p, "SUG-KEREN-PENSIA")),
            maslulBituach: g(p, "SHEM-MASLUL-HABITUAH"),
            maslulBituachCode: g(p, "MASLUL-BITUACH-BAKEREN-PENSIA"),
            mevutachBaKeren: lookup(MEVUTACH_BAKEREN, g(p, "MEVUTACH")),
            sugPolisa:     lookup(SUG_POLISA, g(p, "SUG-POLISA")),
            riskZmaniStart: fmtDate(g(p, "TAARICH-TCHILA-RISK-ZMANI")),
            riskZmaniEnd:   fmtDate(g(p, "TOM-TOKEF-RISK-ZMANI")),
            kisuyIshiKvutzati: lookup(KISUY_ISHY_KVOZATI, g(p, "KISUY-ISHY-KVOZATI")),
            kayamKisuyHizoni:  lookup(IND_YES_NO, g(p, "KAYAM-KISUY-HIZONI")),
            // Financial summary
            redeem, prevYear,
            // Parsed sections
            client,
            employer: empRes.employer || mutzarEmployer,
            employers: empRes.employers,
            agent, employment,
            returns,
            yitrot,
            kisuim:    parseKisuim(p),
            gvia:      parseGvia(p),
            tviot:     parseTviot(p),
            mitriyot:  parseMitriyot(p),
            maslulim:  parseMaslulim(p),
            hafkadot:  parseHafkadot(p),
            annualDeposits: parseAnnualDeposits(p),
            lastDeposit: parseLastDeposit(p),
            flows: parseFlows(p, maasikDict),
            retirementProjections: parseRetirementProjections(p),
            dmeiNihul: parseDmeiNihul(p),
            sheerim:   parseSheerim(p),
            mutavim:   parseMutavim(p),
            debts:     parseDebts(p),
            loans:     loans,
            loan:      loans[0] || null,
            // Flags
            hasShiabud: g(p, "HUTAL-SHIABUD") === "1",
            hasIkul:    g(p, "HUTAL-IKUL") === "1",
            shiabud:    g(p, "HUTAL-SHIABUD") || null,
            ikul:       g(p, "HUTAL-IKUL")    || null,
            profession: g(p, "KOD-MIKTZOA"),
          });
        }
      }
    }
  }
  return { funds: allFunds, taarichBitzua, sugMimshak };
}
